import React from 'react';

function Icon() {
  return (
    <svg width="66" height="59" fill="none" viewBox="0 0 66 59">
      <path fill="#B5CDFF" d="M37.251 4.264a4.264 4.264 0 11-8.528 0 4.264 4.264 0 018.528 0z" opacity="0.98"></path>
      <path
        fill="url(#paint0_linear)"
        d="M31.855 5.34a1.323 1.323 0 012.292 0l22.347 38.706c3.82 6.617-.955 14.888-8.595 14.888H18.102c-7.64 0-12.415-8.27-8.595-14.887L31.855 5.339z"></path>
      <path
        fill="#fff"
        d="M46.352 38.796l-11.073-8.204v-4.91c0-.775-.172-1.556-.511-2.284l-.252-.478a1.774 1.774 0 00-1.626-1.04c-.706 0-1.328.399-1.612 1.012l-.279.532a5.395 5.395 0 00-.498 2.258v4.91l-11.067 8.204c-.975.975-.877.919-.877 2.184a.595.595 0 00.92.502l11.256-6.33s1.23 6.916 1.23 14.61c0 7.694-6.451 9.238-6.451 9.238h15.335s-7.03-1.544-7.03-9.24c0-7.694 1.23-14.606 1.23-14.606l11.256 6.328c.185.119.418.125.608.021a.594.594 0 00.312-.523c0-1.263.102-1.211-.871-2.184z"></path>
      <defs>
        <linearGradient id="paint0_linear" x1="33.001" x2="40.361" y1="3.354" y2="65.22" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4783FF"></stop>
          <stop offset="1" stopColor="#E8DFFF"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Icon;
